import {
  Users, Armchair, RefreshCw, UserCheck, PhoneCall, Briefcase, CreditCard,
  Trophy, Compass, ClipboardList, GitCompare, HeartHandshake, Building2,
  Coins, Handshake, Wallet, Receipt, Globe2, BarChart3, Calculator, Scale,
  TrendingUp, Star, Sparkles, BookOpen, Award, Target, Zap, Heart, Crown,
} from "lucide-react";

export const ICON_MAP = {
  Users, Armchair, RefreshCw, UserCheck, PhoneCall, Briefcase, CreditCard,
  Trophy, Compass, ClipboardList, GitCompare, HeartHandshake, Building2,
  Coins, Handshake, Wallet, Receipt, Globe2, BarChart3, Calculator, Scale,
  TrendingUp, Star, Sparkles, BookOpen, Award, Target, Zap, Heart, Crown,
};

export const ICON_NAMES = Object.keys(ICON_MAP);

export function getIcon(name, fallback = Sparkles) {
  return ICON_MAP[name] || fallback;
}
